import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import $ from "jquery"
import 'magnific-popup'; // Import magnificPopup styles and scripts
import 'magnific-popup/dist/magnific-popup.css'; // Include CSS for magnificPopup
// 
class Photo_gallery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.jquery()
    }

    jquery() {
        $('.image-popup-vertical-fit').magnificPopup({
            type: 'image',
            mainClass: 'mfp-with-zoom',
            gallery: {
                enabled: true,
            },
            zoom: {
                enabled: true,
                duration: 300,
                easing: 'ease-in-out',
                opener: function (openerElement) {
                    return openerElement.is('img') ? openerElement : openerElement.find('img');
                },
            },
        });

        // Filtering functionality
        $('.filter-button').on('click', function () {
            const value = $(this).attr('data-filter');
            if (value === 'all') {
                $('.filter').show('1000');
            } else {
                $('.filter').not(`.${value}`).hide('3000');
                $('.filter').filter(`.${value}`).show('3000');
            }

            // Toggle active class
            $('.filter-button').removeClass('active');
            $(this).addClass('active');
        });

        // Cleanup event listeners
        return () => {
            $('.filter-button').off('click');
        };

    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Photo Gallery
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>News & PR</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Photo Gallery</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="img-gallery-magnific">
                    <div className="container">
                        <div className="row" data-aos="fade-up" data-aos-delay={700}>
                            <div className="col-md-12">
                                <div className="Gallery_section pt-5">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="project__menu-nav">
                                                <button className="filter-button" data-filter="all">
                                                    ALL
                                                </button>
                                                <button class="filter-button" data-filter="Gallary_0">
                                                    ITME AFRICA 2023
                                                </button>
                                                <button className="filter-button" data-filter="Gallary_1">
                                                    India ITME 2022
                                                </button>
                                                <button className="filter-button" data-filter="Gallary_2">
                                                    Textile Week at Dubai Expo
                                                </button>
                                                <button className="filter-button" data-filter="Gallary_3">
                                                    India ITME 2016
                                                </button>
                                                <button className="filter-button" data-filter="Gallary_4">
                                                    GTTES 2015
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row gutter-24 project-active-two">
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-1.jpg"
                                                    title="cultural-program-1"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-1.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-2.jpg"
                                                    title="cultural-program-2"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-2.jpg"
                                                        alt="cultural-program-2"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-3.jpg"
                                                    title="cultural-program-3"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-3.jpg"
                                                        alt="cultural-program-3"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-4.jpg"
                                                    title="cultural-program-4"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-4.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-5.jpg"
                                                    title="cultural-program-5"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-5.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-6.jpg"
                                                    title="cultural-program-6"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-6.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-7.jpg"
                                                    title="cultural-program-7"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-7.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-8.jpg"
                                                    title="cultural-program-8"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-8.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-9.jpg"
                                                    title="cultural-program-9"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/cultural-program-9.jpg"
                                                        alt={1}
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-1.jpg"
                                                    title="Exhibition-1"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-1.jpg"
                                                        alt="Exhibition-1"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-2.jpg"
                                                    title="Exhibition-2"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-2.jpg"
                                                        alt="Exhibition-2"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-3.jpg"
                                                    title="Exhibition-3"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-3.jpg"
                                                        alt="Exhibition-3"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-4.jpg"
                                                    title="Exhibition-4"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-4.jpg"
                                                        alt="Exhibition-4"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-5.jpg"
                                                    title="Exhibition-5"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-5.jpg"
                                                        alt="Exhibition-5"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-6.jpg"
                                                    title="Exhibition-6"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-6.jpg"
                                                        alt="Exhibition-6"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-7.jpg"
                                                    title="Exhibition-7"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-7.jpg"
                                                        alt="Exhibition-7"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-8.jpg"
                                                    title="Exhibition-8"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-8.jpg"
                                                        alt="Exhibition-8"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-9.jpg"
                                                    title="Exhibition-9"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-9.jpg"
                                                        alt="Exhibition-9"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-10.jpg"
                                                    title="Exhibition-10"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-10.jpg"
                                                        alt="Exhibition-10"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-11.jpg"
                                                    title="Exhibition-11"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-11.jpg"
                                                        alt="Exhibition-11"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-12.jpg"
                                                    title="Exhibition-12"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-12.jpg"
                                                        alt="Exhibition-12"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-13.jpg"
                                                    title="Exhibition-13"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-13.jpg"
                                                        alt="Exhibition-13"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-14.jpg"
                                                    title="Exhibition-14"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-14.jpg"
                                                        alt="Exhibition-14"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-15.jpg"
                                                    title="Exhibition-15"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-15.jpg"
                                                        alt="Exhibition-15"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-16.jpg"
                                                    title="Exhibition-16"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-16.jpg"
                                                        alt="Exhibition-16"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-17.jpg"
                                                    title="Exhibition-17"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-17.jpg"
                                                        alt="Exhibition-17"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-18.jpg"
                                                    title="Exhibition-18"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-18.jpg"
                                                        alt="Exhibition-18"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-19.jpg"
                                                    title="Exhibition-19"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-19.jpg"
                                                        alt="Exhibition-19"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-20.jpg"
                                                    title="Exhibition-20"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-20.jpg"
                                                        alt="Exhibition-20"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-21.jpg"
                                                    title="Exhibition-21"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Exhibition-21.jpg"
                                                        alt="Exhibition-21"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-1.jpg"
                                                    title="Inaugural-Program-1"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-1.jpg"
                                                        alt="Inaugural-Program-1"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-2.jpg"
                                                    title="Inaugural-Program-2"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-2.jpg"
                                                        alt="Inaugural-Program-2"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-3.jpg"
                                                    title="Inaugural-Program-3"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-3.jpg"
                                                        alt="Inaugural-Program-3"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-4.jpg"
                                                    title="Inaugural-Program-4"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-4.jpg"
                                                        alt="Inaugural-Program-4"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-5.jpg"
                                                    title="Inaugural-Program-5"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-5.jpg"
                                                        alt="Inaugural-Program-5"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-6.jpg"
                                                    title="Inaugural-Program-6"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-6.jpg"
                                                        alt="Inaugural-Program-6"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-7.jpg"
                                                    title="Inaugural-Program-7"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-7.jpg"
                                                        alt="Inaugural-Program-7"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-8.jpg"
                                                    title="Inaugural-Program-8"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-8.jpg"
                                                        alt="Inaugural-Program-8"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-9.jpg"
                                                    title="Inaugural-Program-9"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-9.jpg"
                                                        alt="Inaugural-Program-9"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-10.jpg"
                                                    title="Inaugural-Program-10"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-10.jpg"
                                                        alt="Inaugural-Program-10"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-11.jpg"
                                                    title="Inaugural-Program-11"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-11.jpg"
                                                        alt="Inaugural-Program-11"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-12.jpg"
                                                    title="Inaugural-Program-12"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-12.jpg"
                                                        alt="Inaugural-Program-12"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-13.jpg"
                                                    title="Inaugural-Program-13"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-13.jpg"
                                                        alt="Inaugural-Program-13"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-14.jpg"
                                                    title="Inaugural-Program-14"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-14.jpg"
                                                        alt="Inaugural-Program-14"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-15.jpg"
                                                    title="Inaugural-Program-15"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Inaugural-Program-15.jpg"
                                                        alt="Inaugural-Program-15"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-2.jpg"
                                                    title="Seminars-2"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-2.jpg"
                                                        alt="Seminars-2"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-3.jpg"
                                                    title="Seminars-3"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-3.jpg"
                                                        alt="Seminars-3"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-4.jpg"
                                                    title="Seminars-4"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-4.jpg"
                                                        alt="Seminars-4"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-5.jpg"
                                                    title="Seminars-5"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-5.jpg"
                                                        alt="Seminars-5"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-6.jpg"
                                                    title="Seminars-6"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-6.jpg"
                                                        alt="Seminars-6"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-7.jpg"
                                                    title="Seminars-7"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-7.jpg"
                                                        alt="Seminars-7"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-8.jpg"
                                                    title="Seminars-8"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-8.jpg"
                                                        alt="Seminars-8"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-9.jpg"
                                                    title="Seminars-9"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-9.jpg"
                                                        alt="Seminars-9"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-10.jpg"
                                                    title="Seminars-10"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-10.jpg"
                                                        alt="Seminars-10"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-11.jpg"
                                                    title="Seminars-11"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-11.jpg"
                                                        alt="Seminars-11"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-12.jpg"
                                                    title="Seminars-12"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-12.jpg"
                                                        alt="Seminars-12"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-13.jpg"
                                                    title="Seminars-13"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-13.jpg"
                                                        alt="Seminars-13"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-14.jpg"
                                                    title="Seminars-14"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-14.jpg"
                                                        alt="Seminars-14"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-15.jpg"
                                                    title="Seminars-15"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-15.jpg"
                                                        alt="Seminars-15"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-16.jpg"
                                                    title="Seminars-16"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-16.jpg"
                                                        alt="Seminars-16"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-17.jpg"
                                                    title="Seminars-17"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-17.jpg"
                                                        alt="Seminars-17"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_0">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_AFRICA_2023/Seminars-18.jpg"
                                                    title="Seminars-18"
                                                >
                                                    <img
                                                        src="assets/img/Gallary/ITME_AFRICA_2023/Seminars-18.jpg"
                                                        alt="Seminars-18"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/1.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/1.jpg" alt={1} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/2.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/2.jpg" alt={2} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/3.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/3.jpg" alt={3} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/4.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/4.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/5.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/5.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/6.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/6.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/7.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/7.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/8.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/8.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/9.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/9.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/10.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/10.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/4.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/4.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/11.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/11.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/12.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/12.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/13.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/13.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/14.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/14.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/15.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/15.jpg" alt={15} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/16.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/16.jpg" alt={16} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/17.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/17.jpg" alt={17} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/18.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/18.jpg" alt={18} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/19.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/19.jpg" alt={19} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/20.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/20.jpg" alt={20} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/21.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/21.jpg" alt={21} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/22.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/22.jpg" alt={22} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/23.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/23.jpg" alt={23} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/24.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/24.jpg" alt={24} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/25.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/25.jpg" alt={25} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/26.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/25.jpg" alt={26} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/27.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/27.jpg" alt={27} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/28.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/28.jpg" alt={28} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/29.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/29.jpg" alt={29} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/30.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/30.jpg" alt={30} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/31.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/31.jpg" alt={31} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/32.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/32.jpg" alt={32} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/33.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/33.jpg" alt={33} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/34.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/34.jpg" alt={34} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/35.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/35.jpg" alt={35} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/36.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/36.jpg" alt={36} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/37.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/37.jpg" alt={37} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/38.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/38.jpg" alt={38} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/39.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/39.jpg" alt={39} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/40.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/40.jpg" alt={40} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/41.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/41.jpg" alt={41} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/42.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/42.jpg" alt={42} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/43.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/43.jpg" alt={43} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/44.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/44.jpg" alt={44} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/45.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/45.jpg" alt={45} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/46.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/46.jpg" alt={46} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/47.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/47.jpg" alt={47} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/48.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/48.jpg" alt={48} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/49.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/49.jpg" alt={49} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/50.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/50.jpg" alt={50} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/51.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/51.jpg" alt={51} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/52.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/52.jpg" alt={52} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/53.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/53.jpg" alt={53} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/54.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/54.jpg" alt={54} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/55.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/55.jpg" alt={55} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/56.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/56.jpg" alt={56} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/57.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/57.jpg" alt={57} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/58.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/58.jpg" alt={58} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/59.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/59.jpg" alt={59} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/60.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/60.jpg" alt={60} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/61.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/61.jpg" alt={61} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/62.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/62.jpg" alt={62} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/63.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/63.jpg" alt={63} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/64.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/64.jpg" alt={64} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/65.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/65.jpg" alt={65} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/66.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/66.jpg" alt={66} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/67.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/67.jpg" alt={67} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/68.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/68.jpg" alt={68} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/69.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/69.jpg" alt={69} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/70.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/70.jpg" alt={70} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/71.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/71.jpg" alt={71} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/72.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/72.jpg" alt={72} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/73.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/73.jpg" alt={73} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/74.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/74.jpg" alt={74} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/75.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/75.jpg" alt={75} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/76.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/76.jpg" alt={76} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/77.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/77.jpg" alt={77} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/78.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/78.jpg" alt={78} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/79.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/79.jpg" alt={79} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/80.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/80.jpg" alt={80} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/81.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/81.jpg" alt={81} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/82.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/82.jpg" alt={82} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/83.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/83.jpg" alt={83} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/84.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/84.jpg" alt={84} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/85.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/85.jpg" alt={85} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/86.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/86.jpg" alt={86} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/87.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/87.jpg" alt={87} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/88.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/88.jpg" alt={88} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/89.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/89.jpg" alt={89} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/90.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/90.jpg" alt={90} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/91.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/91.jpg" alt={91} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/92.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/92.jpg" alt={92} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/93.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/93.jpg" alt={93} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/94.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/94.jpg" alt={94} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/95.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/95.jpg" alt={95} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/96.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/96.jpg" alt={96} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/97.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/97.jpg" alt={97} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/98.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/98.jpg" alt={98} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/99.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/99.jpg" alt={99} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/100.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/100.jpg" alt={100} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/101.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/101.jpg" alt={101} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/102.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/102.jpg" alt={102} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/103.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/103.jpg" alt={103} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/104.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/104.jpg" alt={104} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/105.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/105.jpg" alt={105} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/106.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/106.jpg" alt={106} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/107.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/107.jpg" alt={107} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/108.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/108.jpg" alt={108} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/109.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/109.jpg" alt={109} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/110.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/110.jpg" alt={110} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/111.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/111.jpg" alt={111} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/112.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/112.jpg" alt={112} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/113.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/113.jpg" alt={113} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/114.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/114.jpg" alt={114} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/115.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/115.jpg" alt={115} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/116.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/166.jpg" alt={116} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/117.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/117.jpg" alt={117} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/118.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/118.jpg" alt={118} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/119.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/119.jpg" alt={119} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/120.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/120.jpg" alt={120} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/121.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/121.jpg" alt={121} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/122.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/122.jpg" alt={122} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/123.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/123.jpg" alt={123} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/124.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/124.jpg" alt={124} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/125.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/125.jpg" alt={125} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/126.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/126.jpg" alt={126} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/127.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/127.jpg" alt={127} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/128.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/128.jpg" alt={128} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/129.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/129.jpg" alt={129} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/130.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/130.jpg" alt={130} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/131.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/131.jpg" alt={131} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/132.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/132.jpg" alt={132} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/133.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/133.jpg" alt={133} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/134.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/134.jpg" alt={134} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/135.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/135.jpg" alt={135} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/136.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/136.jpg" alt={136} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/137.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/137.jpg" alt={137} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/138.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/138.jpg" alt={138} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/139.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/139.jpg" alt={139} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/140.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/140.jpg" alt={140} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/141.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/141.jpg" alt={141} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/142.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/142.jpg" alt={142} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/143.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/143.jpg" alt={143} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/144.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/144.jpg" alt={144} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/145.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/145.jpg" alt={145} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/146.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/146.jpg" alt={146} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/147.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/147.jpg" alt={147} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/148.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/148.jpg" alt={148} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/149.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/149.jpg" alt={149} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/150.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/150.jpg" alt={150} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/151.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/151.jpg" alt={151} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/151.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/152.jpg" alt={152} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/153.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/153.jpg" alt={154} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/154.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/155.jpg" alt={155} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/156.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/156.jpg" alt={156} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/157.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/157.jpg" alt={157} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/158.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/158.jpg" alt={158} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/159.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/159.jpg" alt={159} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/160.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/160.jpg" alt={160} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/161.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/161.jpg" alt={161} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/162.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/162.jpg" alt={162} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/163.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/163.jpg" alt={163} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/164.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/164.jpg" alt={164} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/165.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/165.jpg" alt={165} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/166.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/166.jpg" alt={166} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/167.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/167.jpg" alt={167} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/168.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/168.jpg" alt={168} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/169.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/169.jpg" alt={169} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/170.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/170.jpg" alt={170} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/171.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/171.jpg" alt={171} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/172.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/172.jpg" alt={172} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/173.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/173.jpg" alt={173} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/174.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/174.jpg" alt={174} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/175.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/175.jpg" alt={175} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/176.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/176.jpg" alt={176} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/177.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/177.jpg" alt={177} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/178.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/178.jpg" alt={178} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/179.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/179.jpg" alt={179} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/180.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/180.jpg" alt={180} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/181.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/181.jpg" alt={181} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/182.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/182.jpg" alt={182} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/183.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/183.jpg" alt={183} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/184.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/184.jpg" alt={184} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/185.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/185.jpg" alt={185} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/186.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/86.jpg" alt={186} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/187.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/187.jpg" alt={187} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/188.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/188.jpg" alt={188} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/189.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/189.jpg" alt={189} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/190.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/190.jpg" alt={190} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/191.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/191.jpg" alt={191} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/192.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/192.jpg" alt={192} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/193.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/193.jpg" alt={193} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/194.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/194.jpg" alt={194} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/195.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/195.jpg" alt={195} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/196.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/196.jpg" alt={196} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/197.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/197.jpg" alt={197} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/198.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/198.jpg" alt={198} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/199.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/199.jpg" alt={199} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/200.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/200.jpg" alt={200} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/201.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/201.jpg" alt={201} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/202.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/202.jpg" alt={202} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/203.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/203.jpg" alt={203} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/204.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/204.jpg" alt={204} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/205.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/205.jpg" alt={205} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/206.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/206.jpg" alt={206} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/207.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/207.jpg" alt={207} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/208.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/208.jpg" alt={208} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/209.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/209.jpg" alt={209} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/210.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/210.jpg" alt={210} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/211.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/211.jpg" alt={211} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/212.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/212.jpg" alt={212} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/213.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/213.jpg" alt={213} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/214.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/214.jpg" alt={214} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/215.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/215.jpg" alt={215} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/216.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/216.jpg" alt={216} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/217.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/217.jpg" alt={217} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/218.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/218.jpg" alt={218} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/219.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/219.jpg" alt={219} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/220.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/220.jpg" alt={220} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/221.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/221.jpg" alt={221} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/222.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/222.jpg" alt={222} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/223.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/223.jpg" alt={223} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/224.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/224.jpg" alt={224} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/225.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/225.jpg" alt={225} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/226.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/226.jpg" alt={226} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/227.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/227.jpg" alt={227} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/228.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/228.jpg" alt={228} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/229.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/229.jpg" alt={229} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/230.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/230.jpg" alt={230} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/231.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/231.jpg" alt={231} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/232.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/232.jpg" alt={232} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/233.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/233.jpg" alt={233} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/234.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/234.jpg" alt={234} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/235.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/235.jpg" alt={235} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/236.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/236.jpg" alt={236} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/237.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/237.jpg" alt={237} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/238.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/238.jpg" alt={238} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/239.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/239.jpg" alt={239} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/240.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/240.jpg" alt={240} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/241.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/241.jpg" alt={241} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/242.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/242.jpg" alt={242} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/243.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/243.jpg" alt={243} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/244.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/244.jpg" alt={244} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/245.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/245.jpg" alt={245} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_1">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2022/246.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2022/246.jpg" alt={246} />
                                                </a>
                                            </div>
                                        </div>
                                        {/* ------------------------------------------------------------------------------ */}
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/1.jpg"
                                                    title="1.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/1.jpg" alt={1} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/2.jpg"
                                                    title="2.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/2.jpg" alt={2} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/3.jpg"
                                                    title="3.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/3.jpg" alt={3} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/4.jpg"
                                                    title="4.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/4.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/5.jpg"
                                                    title="5.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/5.jpg" alt={5} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/6.jpg"
                                                    title="6.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/6.jpg" alt={6} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/7.jpg"
                                                    title="7.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/7.jpg" alt={7} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/8.jpg"
                                                    title="8.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/8.jpg" alt={8} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/9.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/9.jpg" alt={9} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/10.jpg"
                                                    title="10.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/10.jpg" alt={10} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/11.jpg"
                                                    title="11.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/11.jpg" alt={11} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/12.jpg"
                                                    title="12.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/12.jpg" alt={12} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/13.jpg"
                                                    title="13.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/13.jpg" alt={13} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/14.jpg"
                                                    title="14.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/14.jpg" alt={14} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/15.jpg"
                                                    title="15.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/15.jpg" alt={15} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/16.jpg"
                                                    title="16.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/16.jpg" alt={16} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/17.jpg"
                                                    title="17.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/17.jpg" alt={17} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/18.jpg"
                                                    title="18.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/18.jpg" alt={18} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/19.jpg"
                                                    title="19.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/19.jpg" alt={19} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/20.jpg"
                                                    title="20.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/20.jpg" alt={20} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/21.jpg"
                                                    title="21.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/21.jpg" alt={21} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/22.jpg"
                                                    title="22.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/22.jpg" alt={22} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/23.jpg"
                                                    title="23.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/23.jpg" alt={23} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/24.jpg"
                                                    title="24.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/24.jpg" alt={24} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/25.jpg"
                                                    title="25.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/25.jpg" alt={25} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/26.jpg"
                                                    title="26.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/26.jpg" alt={26} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/27.jpg"
                                                    title="27.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/27.jpg" alt={27} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/28.jpg"
                                                    title="28.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/28.jpg" alt={28} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/29.jpg"
                                                    title="29.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/29.jpg" alt={29} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/30.jpg"
                                                    title="30.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/30.jpg" alt={30} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/31.jpg"
                                                    title="31.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/31.jpg" alt={31} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/32.jpg"
                                                    title="32.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/32.jpg" alt={32} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/33.jpg"
                                                    title="33.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/33.jpg" alt={33} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/34.jpg"
                                                    title="34.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/34.jpg" alt={34} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/35.jpg"
                                                    title="35.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/35.jpg" alt={35} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/36.jpg"
                                                    title="36.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/36.jpg" alt={36} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/37.jpg"
                                                    title="37.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/37.jpg" alt={37} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/38.jpg"
                                                    title="38.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/38.jpg" alt={38} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/39.jpg"
                                                    title="39.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/39.jpg" alt={39} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/40.jpg"
                                                    title="40.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/40.jpg" alt={40} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/41.jpg"
                                                    title="41.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/41.jpg" alt={41} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/42.jpg"
                                                    title="42.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/42.jpg" alt={42} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/43.jpg"
                                                    title="43.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/43.jpg" alt={43} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/44.jpg"
                                                    title="44.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/44.jpg" alt={44} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/45.jpg"
                                                    title="45.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/45.jpg" alt={45} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/46.jpg"
                                                    title="46.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/46.jpg" alt={46} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/47.jpg"
                                                    title="47.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/47.jpg" alt={47} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/48.jpg"
                                                    title="48.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/48.jpg" alt={48} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/49.jpg"
                                                    title="49.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/49.jpg" alt={49} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/5050.jpg"
                                                    title="50.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/50.jpg" alt={50} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/51.jpg"
                                                    title="51.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/51.jpg" alt={51} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/52.jpg"
                                                    title="52.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/52.jpg" alt={52} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_2">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/DubaiExpo/53.jpg"
                                                    title="53.jpg"
                                                >
                                                    <img src="assets/img/Gallary/DubaiExpo/53.jpg" alt={53} />
                                                </a>
                                            </div>
                                        </div>
                                        {/* ------------------------------------------------------------------------------ */}
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/1.jpg"
                                                    title="1.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/1.jpg" alt={1} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/2.jpg"
                                                    title="2.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/2.jpg" alt={2} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/3.jpg"
                                                    title="3.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/3.jpg" alt={3} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/4.jpg"
                                                    title="4.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/4.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/5.jpg"
                                                    title="5.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/5.jpg" alt={5} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/6.jpg"
                                                    title="6.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/6.jpg" alt={6} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/7.jpg"
                                                    title="7.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/7.jpg" alt={7} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/8.jpg"
                                                    title="8.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/8.jpg" alt={8} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/9.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/9.jpg" alt={9} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/10.jpg"
                                                    title="10.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/10.jpg" alt={10} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/11.jpg"
                                                    title="11.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/11.jpg" alt={11} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/12.jpg"
                                                    title="12.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/12.jpg" alt={12} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/13.jpg"
                                                    title="13.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/13.jpg" alt={13} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/14.jpg"
                                                    title="14.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/14.jpg" alt={14} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/15.jpg"
                                                    title="15.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/15.jpg" alt={15} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/16.jpg"
                                                    title="16.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/16.jpg" alt={16} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/17.jpg"
                                                    title="17.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/17.jpg" alt={17} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/18.jpg"
                                                    title="18.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/18.jpg" alt={18} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/19.jpg"
                                                    title="19.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/19.jpg" alt={19} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/20.jpg"
                                                    title="20.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/20.jpg" alt={20} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/21.jpg"
                                                    title="21.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/21.jpg" alt={21} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/22.jpg"
                                                    title="22.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/22.jpg" alt={22} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/23.jpg"
                                                    title="23.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/23.jpg" alt={23} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/24.jpg"
                                                    title="24.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/24.jpg" alt={24} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/25.jpg"
                                                    title="25.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/25.jpg" alt={25} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/26.jpg"
                                                    title="26.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/26.jpg" alt={26} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/27.jpg"
                                                    title="27.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/27.jpg" alt={27} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/28.jpg"
                                                    title="28.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/28.jpg" alt={28} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/29.jpg"
                                                    title="29.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/29.jpg" alt={29} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/30.jpg"
                                                    title="30.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/30.jpg" alt={30} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/31.jpg"
                                                    title="31.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/31.jpg" alt={31} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/32.jpg"
                                                    title="32.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/32.jpg" alt={32} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/33.jpg"
                                                    title="33.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/33.jpg" alt={33} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/34.jpg"
                                                    title="34.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/34.jpg" alt={34} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/35.jpg"
                                                    title="35.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/35.jpg" alt={35} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/36.jpg"
                                                    title="36.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/36.jpg" alt={36} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/37.jpg"
                                                    title="37.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/37.jpg" alt={37} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/38.jpg"
                                                    title="38.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/38.jpg" alt={38} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/39.jpg"
                                                    title="39.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/39.jpg" alt={39} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/40.jpg"
                                                    title="40.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/40.jpg" alt={40} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/41.jpg"
                                                    title="41.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/41.jpg" alt={41} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/42.jpg"
                                                    title="42.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/42.jpg" alt={42} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/43.jpg"
                                                    title="43.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/43.jpg" alt={43} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/44.jpg"
                                                    title="44.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/44.jpg" alt={44} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/45.jpg"
                                                    title="45.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/45.jpg" alt={45} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/46.jpg"
                                                    title="46.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/46.jpg" alt={46} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/47.jpg"
                                                    title="47.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/47.jpg" alt={47} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/48.jpg"
                                                    title="48.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/48.jpg" alt={48} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/49.jpg"
                                                    title="49.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/49.jpg" alt={49} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/50.jpg"
                                                    title="50.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/50.jpg" alt={50} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/51.jpg"
                                                    title="51.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/51.jpg" alt={51} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/52.jpg"
                                                    title="52.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/52.jpg" alt={52} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/53.jpg"
                                                    title="53.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/53.jpg" alt={53} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/54.jpg"
                                                    title="54.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/54.jpg" alt={54} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/55.jpg"
                                                    title="55.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/55.jpg" alt={55} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/56.jpg"
                                                    title="56.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/56.jpg" alt={56} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/57.jpg"
                                                    title="57.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/57.jpg" alt={57} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/58.jpg"
                                                    title="58.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/58.jpg" alt={58} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/59.jpg"
                                                    title="59.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/59.jpg" alt={59} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/60.jpg"
                                                    title="60.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/60.jpg" alt={60} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/61.jpg"
                                                    title="61.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/61.jpg" alt={61} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/62.jpg"
                                                    title="62.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/62.jpg" alt={62} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/63.jpg"
                                                    title="63.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/63.jpg" alt={63} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/64.jpg"
                                                    title="64.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/64.jpg" alt={64} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/65.jpg"
                                                    title="65.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/65.jpg" alt={65} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/66.jpg"
                                                    title="66.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/66.jpg" alt={66} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/67.jpg"
                                                    title="67.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/67.jpg" alt={67} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/68.jpg"
                                                    title="68.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/68.jpg" alt={68} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/69.jpg"
                                                    title="69.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/69.jpg" alt={69} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/70.jpg"
                                                    title="70.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/70.jpg" alt={70} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/71.jpg"
                                                    title="71.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/71.jpg" alt={71} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/72.jpg"
                                                    title="72.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/72.jpg" alt={72} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/73.jpg"
                                                    title="73.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/73.jpg" alt={73} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/74.jpg"
                                                    title="74.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/74.jpg" alt={74} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/75.jpg"
                                                    title="75.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/75.jpg" alt={75} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/76.jpg"
                                                    title="76.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/76.jpg" alt={76} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/77.jpg"
                                                    title="77.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/77.jpg" alt={77} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/78.jpg"
                                                    title="78.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/78.jpg" alt={78} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/79.jpg"
                                                    title="79.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/79.jpg" alt={79} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/80.jpg"
                                                    title="80.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/80.jpg" alt={80} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/81.jpg"
                                                    title="81.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/81.jpg" alt={81} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/82.jpg"
                                                    title="82.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/82.jpg" alt={82} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/83.jpg"
                                                    title="83.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/83.jpg" alt={83} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/84.jpg"
                                                    title="84.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/84.jpg" alt={84} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/85.jpg"
                                                    title="85.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/85.jpg" alt={85} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/86.jpg"
                                                    title="86.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/86.jpg" alt={86} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/87.jpg"
                                                    title="87.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/87.jpg" alt={87} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/88.jpg"
                                                    title="88.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/88.jpg" alt={88} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/89.jpg"
                                                    title="89.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/89.jpg" alt={89} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/90.jpg"
                                                    title="90.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/90.jpg" alt={90} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/91.jpg"
                                                    title="91.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/91.jpg" alt={91} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/92.jpg"
                                                    title="92.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/92.jpg" alt={92} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/93.jpg"
                                                    title="93.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/93.jpg" alt={93} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/94.jpg"
                                                    title="94.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/94.jpg" alt={94} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/95.jpg"
                                                    title="95.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/95.jpg" alt={95} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/96.jpg"
                                                    title="96.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/96.jpg" alt={96} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/97.jpg"
                                                    title="97.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/97.jpg" alt={97} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/98.jpg"
                                                    title="98.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/98.jpg" alt={98} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/99.jpg"
                                                    title="99.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/99.jpg" alt={99} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/100.jpg"
                                                    title="100.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/100.jpg" alt={100} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/101.jpg"
                                                    title="101.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/101.jpg" alt={101} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/102.jpg"
                                                    title="102.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/102.jpg" alt={102} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/103.jpg"
                                                    title="103.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/103.jpg" alt={103} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/104.jpg"
                                                    title="104.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/104.jpg" alt={104} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/105.jpg"
                                                    title="105.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/105.jpg" alt={105} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/106.jpg"
                                                    title="106.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/106.jpg" alt={106} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/107.jpg"
                                                    title="107.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/107.jpg" alt={107} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/108.jpg"
                                                    title="108.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/108.jpg" alt={108} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/109.jpg"
                                                    title="109.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/109.jpg" alt={109} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/110.jpg"
                                                    title="110.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/110.jpg" alt={110} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/111.jpg"
                                                    title="111.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/111.jpg" alt={111} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/112.jpg"
                                                    title="112.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/112.jpg" alt={112} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/113.jpg"
                                                    title="113.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/113.jpg" alt={113} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/114.jpg"
                                                    title="114.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/114.jpg" alt={114} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/115.jpg"
                                                    title="115.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/115.jpg" alt={115} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/116.jpg"
                                                    title="116.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/116.jpg" alt={116} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/117.jpg"
                                                    title="117.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/117.jpg" alt={117} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/118.jpg"
                                                    title="118.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/118.jpg" alt={118} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/119.jpg"
                                                    title="119.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/119.jpg" alt={119} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/120.jpg"
                                                    title="120.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/120.jpg" alt={120} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/121.jpg"
                                                    title="121.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/121.jpg" alt={121} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/122.jpg"
                                                    title="122.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/122.jpg" alt={122} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/123.jpg"
                                                    title="123.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/123.jpg" alt={123} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_3">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/ITME_2016/124.jpg"
                                                    title="124.jpg"
                                                >
                                                    <img src="assets/img/Gallary/ITME_2016/124.jpg" alt={124} />
                                                </a>
                                            </div>
                                        </div>
                                        {/* ------------------------------------------------------------------------------ */}
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/1.jpg"
                                                    title="1.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/1.jpg" alt={1} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/2.jpg"
                                                    title="2.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/2.jpg" alt={2} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/3.jpg"
                                                    title="3.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/3.jpg" alt={3} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/4.jpg"
                                                    title="4.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/4.jpg" alt={4} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/5.jpg"
                                                    title="5.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/5.jpg" alt={5} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/6.jpg"
                                                    title="6.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/6.jpg" alt={6} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/7.jpg"
                                                    title="7.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/7.jpg" alt={7} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/8.jpg"
                                                    title="8.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/8.jpg" alt={8} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/9.jpg"
                                                    title="9.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/9.jpg" alt={9} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/10.jpg"
                                                    title="10.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/10.jpg" alt={10} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/11.jpg"
                                                    title="11.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/11.jpg" alt={11} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/12.jpg"
                                                    title="12.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/12.jpg" alt={12} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/13.jpg"
                                                    title="13.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/13.jpg" alt={13} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/14.jpg"
                                                    title="14.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/14.jpg" alt={14} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/15.jpg"
                                                    title="15.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/15.jpg" alt={15} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/16.jpg"
                                                    title="16.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/16.jpg" alt={16} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/17.jpg"
                                                    title="17.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/17.jpg" alt={17} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/18.jpg"
                                                    title="18.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/18.jpg" alt={18} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/19.jpg"
                                                    title="19.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/19.jpg" alt={19} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/20.jpg"
                                                    title="20.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/20.jpg" alt={20} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/21.jpg"
                                                    title="21.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/21.jpg" alt={21} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/22.jpg"
                                                    title="22.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/22.jpg" alt={22} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/23.jpg"
                                                    title="23.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/23.jpg" alt={23} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/24.jpg"
                                                    title="24.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/24.jpg" alt={24} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/25.jpg"
                                                    title="25.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/25.jpg" alt={25} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/26.jpg"
                                                    title="26.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/26.jpg" alt={26} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/27.jpg"
                                                    title="27.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/27.jpg" alt={27} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/28.jpg"
                                                    title="28.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/28.jpg" alt={28} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/29.jpg"
                                                    title="29.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/29.jpg" alt={29} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/30.jpg"
                                                    title="30.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/30.jpg" alt={30} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/31.jpg"
                                                    title="31.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/31.jpg" alt={31} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/32.jpg"
                                                    title="32.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/32.jpg" alt={32} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/33.jpg"
                                                    title="33.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/33.jpg" alt={33} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/34.jpg"
                                                    title="34.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/34.jpg" alt={34} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/35.jpg"
                                                    title="35.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/35.jpg" alt={35} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/36.jpg"
                                                    title="36.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/36.jpg" alt={36} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/37.jpg"
                                                    title="37.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/37.jpg" alt={37} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/38.jpg"
                                                    title="38.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/38.jpg" alt={38} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/39.jpg"
                                                    title="39.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/39.jpg" alt={39} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/40.jpg"
                                                    title="40.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/40.jpg" alt={40} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/41.jpg"
                                                    title="41.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/41.jpg" alt={41} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/42.jpg"
                                                    title="42.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/42.jpg" alt={42} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/43.jpg"
                                                    title="43.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/43.jpg" alt={43} />
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6 filter Gallary_4">
                                            <div className="magnific-img galllary_img_div">
                                                <a
                                                    className="image-popup-vertical-fit"
                                                    href="assets/img/Gallary/GTTES_2015/44.jpg"
                                                    title="44.jpg"
                                                >
                                                    <img src="assets/img/Gallary/GTTES_2015/44.jpg" alt={44} />
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Photo_gallery));